import React from 'react';
import { 
  Facebook, 
  Instagram, 
  Twitter, 
  Linkedin,
  MessageCircle,
  Share2
} from 'lucide-react';

const SocialShareButtons = ({ url, title, className = '' }) => {
  const shareUrl = url || window.location.href;
  const shareTitle = title || 'Check out LifeWave products!';

  const socialLinks = [
    {
      name: 'Facebook',
      icon: Facebook,
      color: 'bg-blue-600 hover:bg-blue-700',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'Twitter',
      icon: Twitter,
      color: 'bg-sky-500 hover:bg-sky-600',
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      color: 'bg-blue-700 hover:bg-blue-800',
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}`
    },
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      color: 'bg-green-500 hover:bg-green-600',
      url: `https://wa.me/?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`
    }
  ];

  const handleShare = (socialUrl) => {
    window.open(socialUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Share2 className="w-4 h-4 text-slate-400" />
      {socialLinks.map((social) => (
        <button
          key={social.name}
          onClick={() => handleShare(social.url)}
          className={`w-8 h-8 rounded-full ${social.color} text-white flex items-center justify-center transition-transform hover:scale-110`}
          title={`Share on ${social.name}`}
          data-testid={`share-${social.name.toLowerCase()}`}
        >
          <social.icon className="w-4 h-4" />
        </button>
      ))}
    </div>
  );
};

export default SocialShareButtons;
